import React, { useState } from 'react'
import './index.less'
import { getDiscountCoupon } from '../../pages/charge-vip/api'
import { getCurrentUid } from '../../api/web-h5-common'
import Toast from '@xpeng/rc-toast'
import { priceFormat } from '../../utils/common'
import moment from 'moment'
interface VipCouponCardPropsRule {
    couponInfo: any
    disabled?: boolean
    className?: string
    afterReceive?: () => void
}
const VipCouponCard = (props: VipCouponCardPropsRule) => {
    const isIOS = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const { couponInfo, disabled = false, className, afterReceive } = props
    const [ifShowDesc, setIfShowDesc] = useState(false);
    const getTimeDesc = delta => {
        if (!delta) {
            return null;
        }
        delta = delta / 1000;
        let res: string | null = null;
        let year =
            Math.floor(delta / 86400 / 365) > 0
                ? Math.floor(delta / 86400 / 365) + "年"
                : "";
        let runTime = delta % (86400 * 365);
        let month =
            Math.floor(runTime / 86400 / 30) > 0
                ? Math.floor(runTime / 86400 / 30) + "个月"
                : "";
        runTime = runTime % (86400 * 30);
        let day =
            Math.floor(runTime / 86400) > 0 ? Math.floor(runTime / 86400) + "天" : "";
        runTime = runTime % 86400;
        let hour =
            Math.floor(runTime / 3600) > 0 ? Math.floor(runTime / 3600) + "小时" : "";
        runTime = runTime % 3600;
        let minute =
            Math.floor(runTime / 60) > 0 ? Math.floor(runTime / 60) + "分钟" : "";
        runTime = runTime % 60;
        let second = runTime;

        console.log(year + month + day + hour + minute);

        if (year && year !== "") {
            res = year + month + day;
        } else if (month && month !== "") {
            res = month + day;
        } else {
            res = year + month + day + hour + minute || "";
        }
        return res;
    };
    const showDesc = () => {
        setIfShowDesc(!ifShowDesc);
    };

    const getTimeInfo = time => {
        if (time) {
            return `${time}:00`;
        } else if (time === 0) {
            return "00:00";
        } else {
            return "--:--";
        }
    }

    const receiveCoupon = async () => {
        getCurrentUid().then(async userId => {
            let receiveRes = await getDiscountCoupon({
                couponPlanId: couponInfo.couponPlanId,
                uid: userId
            })
            if (receiveRes.code === 200) {
                Toast.show('领券成功', {
                    containerStyle: {
                        zIndex: 9999
                    }
                })
                afterReceive && afterReceive()
            }
        })
    }

    const getCouponStatus = (status) => {
        switch (status) {
            case 1:
                return '生效中'
            case 2:
                return '已使用'
            case 3:
                return '已使用'
            case 4:
                return '已过期'
            default:
                return null
        }
    }

    const geRemainTime = (time) => {
        let delta = moment(time).valueOf() - moment().valueOf()
        console.log(delta, 'delta')
        if (delta < 24 * 3600 * 1000) {
            return getTimeDesc(delta)
        } else {
            return null
        }
    }

    return <div className={`vip-coupon-card-container ${disabled ? 'vip-coupon-card-container-disabled' : ''} ${className}`}>
        <div className="conpou-bg">
            <div className="conpou-wrapper-left">
                <div className='coupon-wrapper-left-price'>
                    {couponInfo?.couponType !== 5 && <div className="conpou-wrapper-unit">¥</div>}
                    <div className="conpou-wrapper-num">
                        {couponInfo?.couponType !== 5 ? priceFormat(couponInfo?.couponFee) || "---" : '兑换'}
                    </div>
                </div>
                {
                    couponInfo?.couponType !== 5
                        ?
                        <div className='price-limit'>{`满${priceFormat(couponInfo?.thresholdPrice) || "---"}元可用`}</div>
                        :
                        <div className='price-limit'>无门槛可用</div>
                }
            </div>
            <div className="conpou-wrapper-right">
                <div className="conpou-wrapper-top-tip">
                    {getCouponStatus(couponInfo.couponState)}
                </div>
                <div className="conpou-wrapper">
                    <div style={{ width: '100%' }}>
                        <div className="conpou-wrapper-title">
                            {couponInfo?.couponPlanName || "---"}
                        </div>

                        <div className="conpou-wrapper-grey-detail">
                            {
                                couponInfo?.showReceiveBtn
                                    ?
                                    (`可用于购买：${couponInfo?.skuInfos?.reduce((a, b, c) => { return a + b?.skuName + `${c === couponInfo?.skuInfos?.length - 1 ? '' : '、'}` }, '')}`)
                                    :
                                    `${couponInfo?.beginTime?.split(' ')[0]}至${couponInfo?.expireTime?.split(' ')[0]}`

                            }
                        </div>
                        {!!geRemainTime(couponInfo?.expireTime) && !disabled && <div className='height-light-remain-time'>{geRemainTime(couponInfo?.expireTime)}</div>}
                    </div>
                    <div
                        className="conpou-wrapper-bottom"
                    >
                        <div
                            className='conpou-use-rule'
                            onClick={showDesc}
                        >
                            <div className="conpou-use-rule-text">使用规则</div>
                            {ifShowDesc ? (
                                <div className="conpou-wrapper-arrow-up" />
                            ) : (
                                <div className="conpou-wrapper-arrow-down" />
                            )}
                        </div>
                        {
                            !!couponInfo?.showReceiveBtn
                            &&
                            <div className='receive-btn' onClick={receiveCoupon}>领取</div>
                        }
                    </div>
                </div>
            </div>
        </div>
        {ifShowDesc && (
            <div className="conpou-rule-detail">
                {couponInfo?.couponPlanDesc || "---"}
            </div>
        )}
    </div>
}
export default VipCouponCard